import { FC, PropsWithChildren } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import { RootState } from "@/utils/store";

interface GuestRouteProps extends PropsWithChildren {
  redirectTo?: string;
}

const GuestRoute: FC<GuestRouteProps> = ({ children, redirectTo = "/" }) => {
  const isGuest = useSelector((state: RootState) => !!!state.auth.user);

  if (!isGuest) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
